import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Benefits/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[{ title: 'Membership Benefits', href: '' as Route }]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <h1 className={cn('header__title')}>
              Freight Forwarders Association Benefits
            </h1>
            <p className={cn('header__title-description')}>
              Join a global alliance built to empower freight forwarders with unparalleled benefits.
              From real-time shipping leads to premium networking opportunities, DFA unlocks the tools,
              connections, and resources you need to grow and succeed.
            </p>
          </div>
          <div className={cn('header__buttons-box')}>
            <Link
              className={cn('header__button-explore')}
              href="#cards"
            >
              Explore Our Benefits
            </Link>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link
              className={cn('header__button-join')}
              href="/membership"
            >
              Join DFA Today
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionHeader;